import { createApp } from 'vue'
import VConsole from 'vconsole';
// import TDesign from 'tdesign-vue-next';

import 'tdesign-vue-next/es/style/index.css';

// 只在 dev.gench.edu.cn 域名下启用 VConsole
if (location.hostname === 'dev.gench.edu.cn') {
    new VConsole();
}

import './style/reset.less';
import './style/font-family.less';
import './style/theme/index.less';

import { store } from './store/index_SignIn';
import router from './router/index_SignIn';
import { i18n } from './i18n';

import App from './App_SignIn.vue'

const app = createApp(App);

// app.use(TDesign);
app.use(store);
app.use(router);
app.use(i18n);

app.mount('#app');
